export default "__VITE_ASSET__b6450827__"